import WrongAnswer from '../wrongAnswer';

/**
 * Create the action
 */

const { thunk, request, success, error } = WrongAnswer.store((data, fetch) =>
    fetch.post('/wrong-answer', data)
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
